export default "__VITE_ASSET__ECFEqCNW__"